import { useTranslation } from 'react-i18next'
import type { IFilterOption } from '@rankmi/rankmi-table/dist/interfaces/filterProps'

const prefix = 'configuration.segments.list.table.headers'

const useSegmentColumnsFilters = () => {
  const { t } = useTranslation()

  const filtersColumns: IFilterOption[] = [
    {
      label: t(`${prefix}.name`),
      value: 'name',
      type: 'string',
    },
    {
      label: t(`${prefix}.usersCount`),
      value: 'users_count',
      type: 'number',
    },
  ]

  return {
    filtersColumns,
  }
}

export default useSegmentColumnsFilters
